import { Config } from '../config';
import { AbleConfigSchema } from '../interfaces/ableConfigSchema';
import { HttpService } from './http.service';

const path = Config.API;

export abstract class AbleService {
  public static getAbleConfigSchema = (version: string): Promise<AbleConfigSchema> => {
    return HttpService.fetchAuthorized(`${path}/config/schemas/able-config/${version}.json`);
  };
}
